<div class="mentor-profile-container">
  <div *ngIf="isLoading" class="loading-container">
    <p>Cargando perfil del mentor...</p>
  </div>

  <div *ngIf="!isLoading && mentor" class="mentor-content">
    <div class="scrollable-content">
      <!-- Breadcrumb Navigation -->
      <div class="breadcrumb">
        <span class="breadcrumb-item" (click)="goBack()">Expertos</span>
        <span class="breadcrumb-separator">/</span>
        <span class="breadcrumb-item current">Perfil de experto</span>
      </div>

      <!-- Hero Section with Image and About Me -->
      <div class="hero-section">
        <!-- Left: Profile Image -->
        <div class="profile-image-container">
          <img [src]="getProfilePhotoUrl()" alt="{{mentor.name}}" class="profile-image" />
        </div>

        <!-- Right: About Me Section -->
        <div class="about-me-container">
          <div class="about-header">
            <h2 class="about-title">Sobre mi : {{mentor.name }}</h2>
            <button class="schedule-btn-hero desktop-only" (click)="scrollToScheduling()">
              Agendar
            </button>
          </div>
          <!-- <div class="expert-name-title">{{mentor.name }}</div> -->
          <div class="expert-categories-container">
            <span class="expert-category-tag" *ngFor="let category of getExpertCategories()">
              {{ category.name }}
            </span>
            <span class="expert-category-tag" *ngIf="getExpertCategories().length === 0">
              Experto
            </span>
          </div>
          <p class="about-text" [innerHTML]="formatTextWithBreaks(mentor.coachProfileData?.aboutMentor)">
          </p>

          <!-- LinkedIn Link -->
          <div class="about-linkedin" *ngIf="mentor.coachProfileData?.contactLinks?.linkedin">
            <a [href]="normalizeLinkedInUrl(mentor.coachProfileData?.contactLinks?.linkedin)" target="_blank" rel="noopener noreferrer" class="linkedin-link-about">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                <path
                  d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
              </svg>
            </a>
          </div>
        </div>
      </div>

      <!-- Session Info Cards -->
      <div class="session-info-container">
        <div class="session-info">
          <div class="info-card">
            <span class="info-label">SESIÓN</span>
            <span class="info-value">Individual</span>
          </div>
          <div class="info-card">
            <span class="info-label">TIPO</span>
            <span class="info-value">Virtual</span>
          </div>
          <div class="info-card">
            <span class="info-label">TIEMPO HASTA</span>
            <span class="info-value">60 min</span>
          </div>
          <div class="info-card">
            <span class="info-label">EXPERIENCIA</span>
            <span class="info-value">+ {{ mentor.coachProfileData?.yearsOfExperience || '0' }} años</span>
          </div>
        </div>
      </div>

      <!-- Content Sections -->
      <div class="content-sections">
        <!-- About Section - Removed from here since it's now in the hero section -->

        <!-- Datos curiosos - Mitad izquierda -->
        <div class="section-half">
          <h2 class="section-title">Datos curiosos</h2>
          <ul class="experience-list">
            <li *ngFor="let description of getProfessionalDescriptions()" class="description-item">
              {{ description }}
            </li>
            <!-- Mostrar mensaje si no hay descripciones -->
            <li *ngIf="!getProfessionalDescriptions() || getProfessionalDescriptions().length === 0"
              class="no-descriptions">
              No hay datos curiosos disponibles
            </li>
          </ul>
        </div>


        <!-- Specialties Section -->
        <div class="content-section" *ngIf="hasSpecialtyTags">
          <h2 class="section-title">Especialidades</h2>
          <div class="specialties-tags">
            <span *ngFor="let tag of specialtyTags" class="specialty-tag">
              {{ tag }}
            </span>
          </div>
        </div>

        <!-- Sección combinada: Datos curiosos y Logros -->
        <div class="content-section combined-sections">


          <!-- Logros y experiencia - Mitad derecha -->
          <div class="section-half">
            <h2 class="section-title">Logros y experiencia destacada</h2>
            <ul class="experience-list">
              <li *ngFor="let summary of getExperienceSummaries()" class="experience-item">
                {{ summary }}
              </li>
              <!-- Mostrar mensaje si no hay resúmenes -->
              <li *ngIf="!getExperienceSummaries() || getExperienceSummaries().length === 0" class="no-experience">
                No hay información de experiencia disponible
              </li>
            </ul>
          </div>
        </div>


      </div>

      <!-- Scheduling Modal -->
      <div class="modal-overlay" *ngIf="showSchedulingModal" (click)="closeSchedulingModal()">
        <div class="modal-content" (click)="$event.stopPropagation()">
          <!-- Modal Header -->
          <div class="modal-header">
            <button class="close-btn" (click)="closeSchedulingModal()">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <line x1="18" y1="6" x2="6" y2="18"></line>
                <line x1="6" y1="6" x2="18" y2="18"></line>
              </svg>
            </button>
          </div>

          <!-- Modal Body -->
          <div class="modal-body">
            <!-- Description Text -->
            <p class="modal-description">
              Selecciona el día y la hora con tu experto. Puedes comprar 3 horas con un Experto por día.
            </p>

            <!-- Scheduling Layout Container -->
            <div class="scheduling-layout">
              <!-- Calendar Container -->
              <div class="calendar-container">
                <!-- Month Navigation -->
                <div class="month-navigation">
                  <button class="nav-arrow" (click)="navigateToPreviousMonth()">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                      <polyline points="15,18 9,12 15,6"></polyline>
                    </svg>
                  </button>
                  <h3 class="month-title">{{ getCurrentMonth() }}</h3>
                  <button class="nav-arrow" (click)="navigateToNextMonth()">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                      <polyline points="9,18 15,12 9,6"></polyline>
                    </svg>
                  </button>
                </div>

                <!-- Calendar Grid -->
                <div class="calendar-grid">
                  <!-- Day Headers -->
                  <div class="calendar-header">
                    <div class="day-header">Lun</div>
                    <div class="day-header">Mar</div>
                    <div class="day-header">Mie</div>
                    <div class="day-header">Jue</div>
                    <div class="day-header">Vie</div>
                    <div class="day-header">Sab</div>
                    <div class="day-header">Dom</div>
                  </div>

                  <!-- Calendar Days -->
                  <div class="calendar-body">
                    <div *ngFor="let day of calendarDays" class="calendar-day" [ngClass]="{
                      'other-month': !day.isCurrentMonth,
                      'selected': day.isSelected,
                      'today': day.isToday,
                      'available': day.isAvailable && day.isCurrentMonth,
                      'unavailable': !day.isAvailable || !day.isCurrentMonth
                    }" (click)="selectCalendarDay(day)">
                      {{ day.dayNumber }}
                    </div>
                  </div>
                </div>
              </div>

              <!-- Time Selection -->
              <div class="time-selection">
                <h4 class="time-title">Elige tu horario</h4>

                <!-- Información de suscripción -->
                <div class="subscription-info"
                  style="background: #f8f9fa; padding: 12px; margin: 12px 0; border-radius: 8px; border-left: 4px solid #CE0024; font-size: 14px;">
                  <div style="display: flex; align-items: center; gap: 8px; margin-bottom: 8px;">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" style="color: #CE0024;">
                      <path
                        d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
                    </svg>
                    <strong style="color: #CE0024;">Tu suscripción: {{ getUserSubscriptionInfo() }}</strong>
                  </div>
                  <div style="color: #6c757d; font-size: 13px;">
                    Horarios seleccionados: {{ selectedTimeSlots.length }}/{{ maxTimeSlotsAllowed }}
                  </div>
                </div>

                <!-- Debug Info (temporal) -->
                <div class="debug-info" *ngIf="selectedCalendarDay"
                  style="background: #f0f0f0; padding: 10px; margin: 10px 0; border-radius: 5px; font-size: 12px;display: none;">
                  <strong>Debug Info:</strong><br>
                  Fecha seleccionada: {{ selectedCalendarDay.date | date:'yyyy-MM-dd' }}<br>
                  Total horarios disponibles: {{ availableTimeSlots.length }}<br>
                  Horarios: {{ availableTimeSlotsFormatted }}
                  <br><br>
                </div>

                <div class="time-slots-grid" *ngIf="selectedCalendarDay && availableTimeSlots.length > 0">
                  <button *ngFor="let slot of availableTimeSlots" class="time-slot" [ngClass]="{
                     'selected': slot.selected,
                     'booked': slot.isBooked && !slot.isPastTime,
                     'past-time': slot.isPastTime
                   }" (click)="selectTimeSlot(slot)" [disabled]="slot.isBooked || slot.isPastTime"
                    [title]="slot.isPastTime ? 'Horario no disponible (ya pasó)' : (slot.isBooked ? 'Horario ya reservado' : 'Horario disponible')">
                    {{ slot.displayTime }}
                  </button>
                </div>
                <div class="no-date-selected" *ngIf="!selectedCalendarDay">
                  <p>Selecciona una fecha para ver los horarios disponibles</p>
                </div>
                <div class="no-slots-available" *ngIf="selectedCalendarDay && availableTimeSlots.length === 0">
                  <p>No hay horarios disponibles para esta fecha</p>
                </div>
              </div>
            </div>
          </div>

          <!-- Modal Footer -->
          <div class="modal-footer2" *ngIf="selectedCalendarDay && selectedTimeSlots.length > 0">
            <button class="confirm-btn" [disabled]="selectedTimeSlots.length === 0 || isLoading"
              (click)="showPurchaseSummary()">
              Confirmar {{ selectedTimeSlots.length }} Cita{{ selectedTimeSlots.length > 1 ? 's' : '' }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Purchase Summary Modal -->
    <div class="modal-overlay" *ngIf="showPurchaseSummaryModal" (click)="closePurchaseSummaryModal()">
      <div class="modal-content purchase-summary-modal" (click)="$event.stopPropagation()">
        <!-- Modal Header -->
        <div class="modal-header">
          <h3 class="modal-title">{{ currentStep === 1 ? 'Resumen de compra' : 'Pago' }}</h3>
          <button class="close-btn" (click)="closePurchaseSummaryModal()">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </button>
        </div>

        <!-- Step Indicator -->
        <div class="step-indicator"
          style="display: flex; align-items: center; justify-content: center; margin: 12px 0 16px 0; padding: 0 24px; position: relative;">
          <div class="step" [class.active]="currentStep === 1" [class.completed]="currentStep > 1"
            style="display: flex; flex-direction: column; align-items: center; position: relative;">
            <div class="step-number"
              style="width: 28px; height: 28px; border-radius: 50%; background: #10b981; color: white; display: flex; align-items: center; justify-content: center; font-weight: 600; font-size: 12px; margin-bottom: 6px; transition: all 0.3s ease; box-shadow: 0 0 0 3px rgba(16, 185, 129, 0.2);">
              1</div>
            <span class="step-label"
              style="font-size: 11px; color: #10b981; font-weight: 600; text-transform: uppercase; letter-spacing: 0.5px; transition: all 0.3s ease;">Resumen</span>
          </div>
          <div class="step-line"
            style="width: 50px; height: 2px; background: #e5e7eb; margin: 0 12px; margin-bottom: 6px;"></div>
          <div class="step" [class.active]="currentStep === 2"
            style="display: flex; flex-direction: column; align-items: center; position: relative;">
            <div class="step-number"
              style="width: 28px; height: 28px; border-radius: 50%; background: #dc2626; color: white; display: flex; align-items: center; justify-content: center; font-weight: 600; font-size: 12px; margin-bottom: 6px; transition: all 0.3s ease; box-shadow: 0 0 0 3px rgba(220, 38, 38, 0.2);">
              2</div>
            <span class="step-label"
              style="font-size: 11px; color: #dc2626; font-weight: 600; text-transform: uppercase; letter-spacing: 0.5px; transition: all 0.3s ease;">Pago</span>
          </div>
        </div>

        <!-- Modal Body -->
        <div class="modal-body">
          <!-- Step 1: Purchase Summary -->
          <div class="step-content" *ngIf="currentStep === 1">
            <div class="purchase-summary">
              <div class="summary-item">
                <span class="summary-label">Experta:</span>
                <span class="summary-value">{{ mentor.name }}</span>
              </div>
              <div class="summary-item">
                <span class="summary-label">Sesión:</span>
                <span class="summary-value">Individual</span>
              </div>
              <div class="summary-item">
                <span class="summary-label">Tipo de sesión:</span>
                <span class="summary-value">Virtual</span>
              </div>
              <div class="summary-item">
                <span class="summary-label">Categoría:</span>
                <span class="summary-value">{{ getExpertCategoriesDisplay() || '-' }}</span>
              </div>
              <div class="summary-item">
                <span class="summary-label">Día:</span>
                <span class="summary-value">{{ getSelectedDateFormatted() }}</span>
              </div>
              <div class="summary-item">
                <span class="summary-label">Horarios seleccionados:</span>
                <span class="summary-value">
                  <div *ngFor="let slot of selectedTimeSlots"
                    style="margin: 4px 0; padding: 4px 8px; background: #f8f9fa; border-radius: 4px; font-size: 13px;">
                    {{ slot.displayTime }}
                  </div>
                </span>
              </div>
              <div class="summary-item">
                <span class="summary-label">Duración total:</span>
                <span class="summary-value">{{ selectedTimeSlots.length * 60 }} min</span>
              </div>
              <div class="summary-item">
                <span class="summary-label">Precio total:</span>
                <span class="summary-value">S/{{ getTotalAmount().toFixed(2) }}</span>
              </div>
            </div>

            <!-- Terms and Conditions Checkbox -->
            <div class="terms-checkbox-section"
              style="margin-top: 24px; padding-top: 20px; border-top: 1px solid #e5e7eb;">
              <label class="checkbox-option"
                style="display: flex; align-items: flex-start; margin-bottom: 16px; cursor: pointer; padding: 6px 0;">
                <input type="checkbox" [(ngModel)]="acceptTerms" style="display: none;">
                <span class="checkbox-custom"
                  style="width: 18px; height: 18px; border: 2px solid #d1d5db; border-radius: 4px; margin-right: 10px; position: relative; transition: all 0.2s ease; flex-shrink: 0; margin-top: 2px;"></span>
                <span class="checkbox-label"
                  style="font-size: 13px; color: #333; font-weight: 500; user-select: none; line-height: 1.4;">
                  Acepto
                  <span class="terms-link" (click)="openTermsModal()"
                    style="color: #dc2626; text-decoration: underline; cursor: pointer;">términos y condiciones</span>
                  de compra
                </span>
              </label>
            </div>
          </div>

          <!-- Step 2: Payment Form -->
          <div class="step-content" *ngIf="currentStep === 2">
            <div class="payment-layout">

              <!-- Left Column: Payment Gateway -->
              <div class="payment-section">
                <h4 class="section-title">Pago</h4>

                <!-- Mensaje cuando el monto es 0 (descuento DESCEXECUTIVE) -->
                <div *ngIf="getFinalAmount() === 0" class="free-appointment-section">
                  <div class="free-appointment-message">
                    <p class="message-title">¡Agenda Gratuita!</p>
                    <p class="message-description">
                      Estás usando uno de tus {{ getExecutiveDiscountNextUse() }}/{{ executiveDiscount?.limiteUso }}
                      expertos gratuitos disponibles.
                    </p>
                    <button class="complete-appointment-btn" (click)="completeFreeAppointment()">
                      Completar Agenda
                    </button>
                  </div>
                </div>

                <!-- Loading indicator -->
                <div *ngIf="getFinalAmount() > 0" id="payment-loading">
                  <div></div>
                  <p>Cargando formulario de pago...</p>
                </div>

                <!-- Payment form container -->
                <div *ngIf="getFinalAmount() > 0" id="payment-form-container" class="payment-form-wrapper">
                  <!-- El contenido se cargará dinámicamente aquí -->
                </div>

                <!-- Botón para continuar con el proceso de pago -->
                <!-- <div class="payment-continue-section" style="margin-top: 20px; text-align: center;">
                <button class="continue-payment-btn" 
                        (click)="abrirModal(getTotalAmount())" 
                        style="padding: 14px 32px; background: #dc2626; color: white; border: none; border-radius: 8px; font-size: 16px; font-weight: 600; cursor: pointer; transition: all 0.2s ease; box-shadow: 0 2px 4px rgba(220, 38, 38, 0.2);">
                  Continuar con el Pago
                </button>
                <p style="font-size: 12px; color: #6b7280; margin-top: 8px; margin-bottom: 0;">
                  Haz clic para cargar el formulario de pago seguro
                </p>
              </div> -->

                <!-- Privacy Notice -->
                <!-- <p class="privacy-notice" style="font-size: 10px; color: #9ca3af; line-height: 1.3; text-align: center; margin: 16px 0 0 0;">
                Al continuar, aceptas que tus datos personales serán utilizados para procesar tu pedido y para otros propósitos descritos en nuestra política de privacidad.
              </p> -->
              </div>

              <!-- Right Column: Purchase Summary -->
              <div class="summary-section">
                <h4 class="section-title">Resumen de compra</h4>

                <div class="summary-items">
                  <div class="summary-item">
                    <span class="summary-label">
                      {{ selectedTimeSlots.length > 1 ? 'Horas Experto' : 'Hora Experto' }}
                    </span>
                    <span class="summary-value">
                      S/{{ getTotalAmount().toFixed(2) }}
                    </span>
                  </div>
                  <div class="summary-item">
                    <span class="summary-label">IGV</span>
                    <span class="summary-value">18%</span>
                  </div>
                </div>

                <!-- Discount Code -->
                <div class="discount-section">
                  <div class="discount-input">
                    <input type="text" placeholder="Código de descuento" class="form-input" [(ngModel)]="discountCode"
                      [disabled]="isApplyingDiscount">
                    <button class="apply-btn" (click)="aplicarDescuento()"
                      [disabled]="isApplyingDiscount || !discountCode.trim()"
                      [style.background]="isApplyingDiscount || !discountCode.trim() ? '#9ca3af' : '#6b7280'"
                      [style.cursor]="isApplyingDiscount || !discountCode.trim() ? 'not-allowed' : 'pointer'">
                      {{ isApplyingDiscount ? 'Aplicando...' : 'Aplicar' }}
                    </button>
                  </div>

                  <!-- Descuento aplicado -->
                  <div *ngIf="appliedDiscount" class="applied-discount">
                    <div>
                      <div>
                        <p>
                          Descuento aplicado: {{ appliedDiscount.codigo }}
                        </p>
                        <p>
                          Ahorras: S/ {{ discountAmount.toFixed(2) }}
                        </p>
                      </div>
                      <button (click)="removerDescuento()">
                        Quitar
                      </button>
                    </div>
                  </div>
                </div>

                <!-- Descuento DESCEXECUTIVE -->
                <div *ngIf="executiveDiscount && !isLoadingExecutiveDiscount" class="executive-discount-section">
                  <div class="executive-discount-checkbox">
                    <label>
                      <input type="checkbox" [(ngModel)]="useExecutiveDiscount"
                        (change)="onUseExecutiveDiscountChange()" [disabled]="appliedDiscount !== null">
                      <span>
                        Deseo usar {{ getExecutiveDiscountNextUse() }}/{{ executiveDiscount.limiteUso }} {{
                        getExecutiveDiscountNextUse() === 1 ? 'experto gratuito' : 'expertos gratuitos' }} disponible{{
                        getExecutiveDiscountNextUse() === 1 ? '' : 's' }}
                      </span>
                    </label>
                  </div>
                </div>

                <!-- Totals -->
                <div class="totals">
                  <div class="total-item">
                    <span class="total-label">Subtotal</span>
                    <span class="total-value">S/{{ getTotalAmount().toFixed(2) }}</span>
                  </div>

                  <!-- Descuento aplicado -->
                  <div *ngIf="appliedDiscount" class="total-item">
                    <span class="total-label">Descuento ({{ appliedDiscount.codigo }})</span>
                    <span class="total-value">-S/{{ discountAmount.toFixed(2) }}</span>
                  </div>

                  <div class="total-item">
                    <span class="total-label">Total</span>
                    <span class="total-value">S/{{ getFinalAmount().toFixed(2) }}</span>
                  </div>
                  <div class="final-total">
                    <span class="final-total-label">Total</span>
                    <span class="final-total-value">S/{{ getFinalAmount().toFixed(2) }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Modal Footer -->
        <div class="modal-footer"
          style="display: flex; justify-content: space-between; align-items: center; padding: 20px 24px 24px; border-top: 1px solid #e5e7eb;">
          <button class="cancel-btn" *ngIf="currentStep === 1" (click)="closePurchaseSummaryModal()"
            style="padding: 14px 24px; background: transparent; color: #666; border: 1px solid #d1d5db; border-radius: 6px; font-size: 15px; font-weight: 500; cursor: pointer; transition: all 0.2s ease; min-width: 140px;">
            Cancelar
          </button>
          <button class="pay-btn" *ngIf="currentStep === 1" (click)="goToPayment()" [disabled]="!acceptTerms"
            style="padding: 14px 24px; background: #dc2626; color: white; border: none; border-radius: 6px; font-size: 15px; font-weight: 600; cursor: pointer; transition: all 0.2s ease; min-width: 140px;"
            [style.background]="acceptTerms ? '#dc2626' : '#9ca3af'"
            [style.cursor]="acceptTerms ? 'pointer' : 'not-allowed'">
            Pagar
          </button>
          <!-- <button class="back-btn" *ngIf="currentStep === 2" (click)="goBackToSummary()" style="padding: 14px 24px; background: transparent; color: #666; border: 1px solid #d1d5db; border-radius: 6px; font-size: 15px; font-weight: 500; cursor: pointer; transition: all 0.2s ease; min-width: 120px;">
           Atrás
         </button> -->
        </div>
      </div>
    </div>

    <!-- Modal de Términos y Condiciones -->
    <div class="modal-overlay" *ngIf="showTermsModal" (click)="closeTermsModal()">
      <div class="modal-content terms-modal" (click)="$event.stopPropagation()">
        <!-- Modal Header -->
        <div class="modal-header">
          <h3 class="modal-title">Términos y Condiciones de Compra</h3>
          <button class="close-btn" (click)="closeTermsModal()">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </button>
        </div>

        <!-- Modal Body -->
        <div class="modal-body">
          <div class="terms-content">
            <h4>1. Información General</h4>
            <p>Al realizar una compra en Phoenix, usted acepta estos términos y condiciones. Estos términos se aplican a
              todas las transacciones realizadas a través de nuestra plataforma.</p>

            <h4>2. Servicios Ofrecidos</h4>
            <p>Phoenix ofrece servicios de mentoría y consultoría con expertos certificados. Los servicios incluyen
              sesiones individuales virtuales con profesionales especializados en diversas áreas.</p>

            <h4>3. Precios y Pagos</h4>
            <p>Los precios están expresados en soles peruanos (S/) e incluyen todos los impuestos aplicables. El pago
              debe realizarse al momento de la reserva. Aceptamos pagos con tarjeta de crédito/débito y transferencias
              bancarias.</p>

            <h4>4. Reservas y Cancelaciones</h4>
            <p>Las reservas están sujetas a disponibilidad del experto. Las cancelaciones deben realizarse con al menos
              24 horas de anticipación para obtener un reembolso completo. Cancelaciones con menos de 24 horas no son
              elegibles para reembolso.</p>

            <h4>5. Política de Reembolsos</h4>
            <p>Los reembolsos se procesarán dentro de 5-10 días hábiles después de la aprobación. Los reembolsos se
              realizarán al método de pago original utilizado en la transacción.</p>

            <h4>6. Responsabilidades del Cliente</h4>
            <p>El cliente se compromete a proporcionar información veraz y actualizada. Debe asistir a las sesiones
              programadas y respetar el tiempo del experto.</p>

            <h4>7. Limitación de Responsabilidad</h4>
            <p>Phoenix no se hace responsable por resultados específicos obtenidos durante las sesiones. Los expertos
              proporcionan orientación profesional, pero los resultados dependen del compromiso del cliente.</p>

            <h4>8. Protección de Datos</h4>
            <p>Respetamos su privacidad y protegemos sus datos personales de acuerdo con nuestra Política de Privacidad
              y las leyes aplicables de protección de datos.</p>

            <h4>9. Modificaciones</h4>
            <p>Nos reservamos el derecho de modificar estos términos en cualquier momento. Las modificaciones entrarán
              en vigor inmediatamente después de su publicación en la plataforma.</p>

            <h4>10. Ley Aplicable</h4>
            <p>Estos términos se rigen por las leyes de la República del Perú. Cualquier disputa será resuelta en los
              tribunales competentes de Lima, Perú.</p>

            <p class="terms-date">Última actualización: {{ getCurrentDate() }}</p>
          </div>
        </div>

        <!-- Modal Footer -->
        <div class="modal-footer">
          <button class="accept-btn" (click)="closeTermsModal()"
            style="padding: 14px 24px; background: #dc2626; color: white; border: none; border-radius: 6px; font-size: 15px; font-weight: 600; cursor: pointer; transition: all 0.2s ease; min-width: 140px;">
            Entendido
          </button>
        </div>
      </div>
    </div>

    <!-- Modal de Política de Cancelación -->
    <div class="modal-overlay" *ngIf="showCancellationPolicyModal" (click)="closeCancellationPolicyModal()">
      <div class="modal-content cancellation-policy-modal" (click)="$event.stopPropagation()"
        style="max-width: 500px; background: white; border-radius: 16px; padding: 0; box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1); animation: slideUp 0.3s ease;">
        <!-- Modal Body -->
        <div class="modal-body" style="padding: 40px 32px;">
          <h3 style="font-size: 20px; font-weight: 700; color: #1a1a1a; margin: 0 0 24px 0; text-align: center; line-height: 1.4;">
            Política de Cancelación y Reprogramación de Sesiones
          </h3>

          <ul style="list-style: none; padding: 0; margin: 0 0 24px 0;">
            <li style="display: flex; align-items: flex-start; margin-bottom: 16px; color: #333; font-size: 15px; line-height: 1.6;">
              <span style="flex-shrink: 0; width: 6px; height: 6px; background: #333; border-radius: 50%; margin-right: 12px; margin-top: 8px;"></span>
              <span>La cancelación debe realizarse con <strong>48 horas de anticipación.</strong></span>
            </li>
            <li style="display: flex; align-items: flex-start; color: #333; font-size: 15px; line-height: 1.6;">
              <span style="flex-shrink: 0; width: 6px; height: 6px; background: #333; border-radius: 50%; margin-right: 12px; margin-top: 8px;"></span>
              <span>Si no te presentas o reprogramas fuera de este tiempo, <strong>no habrá devolución ni reprogramación.</strong></span>
            </li>
          </ul>

          <p style="color: #555; font-size: 14px; line-height: 1.6; margin: 0 0 32px 0; text-align: center;">
            Por favor, confirma que estás de acuerdo antes de continuar con el agendamiento.
          </p>

          <!-- Modal Footer / Buttons -->
          <div style="display: flex; gap: 12px; justify-content: center;">
            <button (click)="closeCancellationPolicyModal()" 
              style="flex: 1; padding: 14px 24px; background: white; color: #dc2626; border: 1px solid #dc2626; border-radius: 8px; font-size: 15px; font-weight: 600; cursor: pointer; transition: all 0.2s ease; min-width: 120px;"
              onmouseover="this.style.background='#fee2e2'" 
              onmouseout="this.style.background='white'">
              Volver
            </button>
            <button (click)="confirmCancellationPolicy()" 
              style="flex: 1; padding: 14px 24px; background: #dc2626; color: white; border: none; border-radius: 8px; font-size: 15px; font-weight: 600; cursor: pointer; transition: all 0.2s ease; min-width: 120px;"
              onmouseover="this.style.background='#b91c1c'" 
              onmouseout="this.style.background='#dc2626'">
              Continuar
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Success Confirmation Modal -->
    <div class="modal-overlay" *ngIf="showSuccessModal" (click)="closeSuccessModal()">
      <div class="modal-content success-modal" (click)="$event.stopPropagation()">
        <div class="success-content">
          <h3 class="success-title">
            {{ selectedTimeSlots.length > 1 ? 'Horas agendadas con éxito' : 'Hora agendada con éxito' }}
          </h3>
          <div class="success-details" *ngIf="selectedTimeSlots.length > 1" style="margin: 20px 0; text-align: center;">
            <p style="color: #666; margin-bottom: 16px;">
              Se han agendado {{ selectedTimeSlots.length }} citas exitosamente:
            </p>
            <div class="booked-times" style="background: #f8f9fa; padding: 16px; border-radius: 8px; margin: 16px 0;">
              <div *ngFor="let slot of selectedTimeSlots"
                style="padding: 8px 0; border-bottom: 1px solid #e5e7eb; color: #333;">
                {{ slot.displayTime }}
              </div>
            </div>
          </div>
          <button class="view-calendar-btn" (click)="viewInCalendar()">
            Ver mi Calendario
          </button>
        </div>
      </div>
    </div>

    <!-- Mobile Footer -->
    <div class="mobile-footer">
      <button class="schedule-btn-mobile" (click)="scrollToScheduling()">
        Agendar
      </button>
    </div>
  </div>
</div>